import dayjs from 'dayjs';
import { OrderStatus, OrderType } from '../order';
import { TaskStatus, TaskType } from '../task';
import { AssetTransactionStatus } from '../asset_transaction/assetTransaction';

export enum MetricInterval {
  hour = 'hour',
  day = 'day',
  month = 'month',
  year = 'year',
}

export enum MetricEntityType {
  productMasterData = 'productMasterData',
  stockLocation = 'stockLocation',
  order = 'order',
  task = 'task',
  asset = 'asset',
  user = 'user',

  transaction = 'transaction',
  action = 'action',

  productTransaction = 'productTransaction',
  taskProduct = 'taskProduct',
  assetTransaction = 'assetTransaction',
}

export class MetricFilter {
  start: Date = dayjs().subtract(7, 'day').startOf('day').toDate();
  end: Date = dayjs().endOf('day').toDate();
  interval: MetricInterval = MetricInterval.day;

  companyIds: string[] = [];

  orderType: OrderType[] = [];
  orderStatus: OrderStatus[] = [];

  taskType: TaskType[] = [];
  taskStatus: TaskStatus[] = [];

  assetStatus: AssetTransactionStatus[] = [];

  constructor(obj: any) {
    Object.assign(this, obj);
  }
}
